import React from "react";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import AlertErrorSmallTokens from "@amzn/meridian-tokens/base/icon/alert-error-small";
import { TextFontWeightB200Token, BorderColorOutlineToken } from "..";
import Text from "@amzn/meridian/text";
import KnowMoreLink from "./knowMoreLink";
import { INELIGIBLE_SITE_MESSAGE } from "../constants/messages";

const NonEligibleMessage = () => {
  return (
    <BorderColorOutlineToken color={"#CC0C39"}>
      <Row
        width="93%"
        spacing="300"
        spacingInset="400"
        alignmentHorizontal="start"
        backgroundColor="#F9D5E2"
        type="outline"
      >
        <Icon tokens={AlertErrorSmallTokens}></Icon>
        <TextFontWeightB200Token>
          <Text type="b200">
            {INELIGIBLE_SITE_MESSAGE}
            <KnowMoreLink></KnowMoreLink>
          </Text>
        </TextFontWeightB200Token>
      </Row>
    </BorderColorOutlineToken>
  );
};

export default NonEligibleMessage;
